RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const versions = data.versions = {};

    versions.getDataVersions = function (props) {
        return $.get(`/api/landscapes/${props.landscapeId}/versions`);
    };
});
